import { Button } from '@asgard/ui-library';
import { useUser } from '@auth0/nextjs-auth0/client';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  StyledOfferFooter,
  StyledOfferFooterActions,
  StyledOfferFooterContainer,
  StyledOfferFooterTitle
} from 'components/jobOffer/footer/OfferFooter.styled';
import { useI18n } from 'hooks/useI18n';
import { useState } from 'react';
import { StyledJoinUsFooterText } from './JoinUsFooter.styled';
import { JoinUsLoggedInModal } from './JoinUsLoggedInModal';
import { JoinUsNotLoggedInModal } from './JoinUsNotLoggedInModal';

const JoinUsFooter: React.FC = () => {
  const { t } = useI18n('join-us');
  const { user } = useUser();

  const [isJoinUsModalOpened, setJoinUsModalOpened] = useState(false);

  const onSendCVClick = (): void => setJoinUsModalOpened(true);
  const onCloseModal = (): void => setJoinUsModalOpened(false);

  return (
    <StyledOfferFooter>
      <StyledOfferFooterContainer>
        <StyledOfferFooterTitle>{t('footer.title')}</StyledOfferFooterTitle>

        <StyledJoinUsFooterText
          dangerouslySetInnerHTML={{
            __html: t('footer.desc')
          }}
        />

        <StyledOfferFooterActions>
          <Button
            onClick={onSendCVClick}
            label={t('footer.sendCV')}
            startIcon={faCheckCircle}
            schema="brand2"
          />
        </StyledOfferFooterActions>
      </StyledOfferFooterContainer>

      {user ? (
        <JoinUsLoggedInModal
          isOpen={isJoinUsModalOpened}
          onClose={onCloseModal}
        />
      ) : (
        <JoinUsNotLoggedInModal
          isOpen={isJoinUsModalOpened}
          onClose={onCloseModal}
        />
      )}
    </StyledOfferFooter>
  );
};

export default JoinUsFooter;
